import { faCrosshairs } from '@fortawesome/free-solid-svg-icons'

import Icon from './common-parts/Icon'

export default function CrosshairsIcon(props) {
  return (
      <Icon
        size="2x"
        transform="down-3"
        {...props}
        icon={faCrosshairs}
      />
  );
}
